import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../shared/state/store';
import { getOnboardingRedirect } from '../../../shared/lib/getOnboardingRedirect';

type GuestOnlyProps = {
  children?: React.ReactNode;
};

export default function GuestOnly(props: GuestOnlyProps): JSX.Element {
  const { isAuthenticated, user, isLoading } = useAuth();

  // Still loading → allow access (will be handled by RequireAuth on private routes)
  if (isLoading) {
    return <>{props.children}</>;
  }

  // Not authenticated → allow access
  if (!isAuthenticated) {
    return <>{props.children}</>;
  }

  // Authenticated → redirect to onboarding (always redirect to new-onboarding)
  const target = getOnboardingRedirect(user) || '/new-onboarding?step=0';
  return <Navigate to={target} replace />;
}